module.exports = __webpack_public_path__ + "static/media/marker--priority-blue.1cdd2d89.svg";